import React from 'react';
import { IconPropTypes } from 'ggApp/types/propTypes';
import { Svg, Path, Rect } from 'react-native-svg';

const Visa = ({ className, size }) => (
    <Svg
        className={className}
        width="36"
        height={size}
        viewBox="0 0 36 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <Rect width="36" height="24" rx="4" fill="#122A96" />
        <Path
            d="M15.37 8.55982L12.5 15.4498H10.61L9.22 9.99982C9.20877 9.87049 9.16416 9.74629 9.09054 9.63936C9.01692 9.53244 8.91681 9.44645 8.8 9.38982C8.24566 9.12432 7.66149 8.92624 7.06 8.79982V8.59982H10.06C10.2585 8.60216 10.4498 8.67475 10.6 8.80473C10.7501 8.9347 10.8493 9.11365 10.88 9.30982L11.62 13.3098L13.46 8.61982L15.37 8.55982ZM22.7 13.1998C22.7 11.3898 20.2 11.2898 20.22 10.4698C20.22 10.2298 20.46 9.95982 20.97 9.89982C21.5697 9.83909 22.1747 9.9428 22.72 10.1998L23.03 8.73982C22.498 8.54519 21.9365 8.44371 21.37 8.43982C19.62 8.43982 18.37 9.36982 18.37 10.7198C18.37 11.7198 19.25 12.2598 19.92 12.5898C20.59 12.9198 20.84 13.1498 20.84 13.4498C20.84 13.9098 20.29 14.1098 19.78 14.1198C19.1463 14.1365 18.5192 13.9883 17.96 13.6898L17.61 15.1998C18.2479 15.4451 18.9266 15.5672 19.61 15.5598C21.47 15.5598 22.68 14.6398 22.69 13.1998H22.7ZM27.31 15.4498H28.94L27.52 8.55982H26.02C25.857 8.55965 25.6976 8.60808 25.5622 8.69892C25.4268 8.78976 25.3216 8.91889 25.26 9.06982L22.61 15.4498H24.47L24.83 14.4498H27.1L27.31 15.4498ZM25.31 13.0098L26.25 10.4298L26.81 12.9998L25.31 13.0098ZM17.87 8.55982L16.41 15.4498H14.67L16.13 8.55982H17.87Z"
            fill="white"
        />
    </Svg>
);

Visa.propTypes = {
    ...IconPropTypes,
};

Visa.defaultProps = {
    className: '',
    size: '24',
    color: '#333333',
};

export default Visa;
